export default "__VITE_ASSET__0_a4fbBI__"